import React from 'react'

import { Dialog, ModalHeader, ModalContent, ModalFooter } from '@/components/Modal'

import { Button } from '@/components/Button'
import { SimulationProfile } from '@/api/types'
import { Form, Modal } from 'react-aria-components'
import { TextField } from '@/components/TextField'

type Props = {
  simulationProfile: SimulationProfile
  onSaveProfile: (profile: SimulationProfile, close: () => void) => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export default function ProfileCreateDialog({
  simulationProfile,
  onSaveProfile,
  isOpen,
  setIsOpen,
}: Props) {
  function handleSubmit(ev: React.FormEvent<HTMLFormElement>, close: () => void): void {
    ev.preventDefault()
    const formData = new FormData(ev.currentTarget)
    const name = formData.get('name') as string
    const description = formData.get('description') as string
    const profile: SimulationProfile = {
      name,
      description,
      userProfile: { ...simulationProfile.userProfile },
    }

    onSaveProfile(profile, close)
  }

  return (
    <>
      <Modal style={{ height: '50%' }} isDismissable isOpen={isOpen}>
        <Dialog>
          <>
            <ModalHeader onClose={() => setIsOpen(false)}>Save Profile</ModalHeader>

            <ModalContent>
              <Form
                style={{ display: 'flex', flexDirection: 'column' }}
                id="myform"
                onSubmit={(formData) => handleSubmit(formData, () => setIsOpen(false))}>
                <TextField name="name" label="Name" isRequired autoFocus={true} />
                <TextField name="description" label="Description" />
              </Form>
            </ModalContent>
            <ModalFooter onClose={() => setIsOpen(false)}>
              <Button variant="primary" form="myform" type="submit">
                Save
              </Button>
            </ModalFooter>
          </>
        </Dialog>
      </Modal>
    </>
  )
}
